module.exports = __webpack_public_path__ + "static/media/img_11.2e375564.png";